import { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../App";
import { processTimer } from "../CoreHelper";
import Arubastini from "../models/Arubastini";
import { MdPersonOutline, MdPerson } from 'react-icons/md';
import { GAME_TYPES } from "../Constants";

export default function View(props) {

  const app = useContext(AppContext);
  const [ data, setData ] = useState(props.data);
  const [ index, setIndex ] = useState(props.index);

  useEffect(() => {
    setData(props.data);
  }, [ props.data ])

  useEffect(() => {
    setIndex(props.index);
  }, [ props.index ])
  
  return (
    <div className="coreGameChatMessage" data-from-user={data.senderId === Number(app.userId)}>
      <div id={"chat-message-"+index}>
        {data.message}
      </div>
    </div>
  )
  
}